import { TextVariant } from './types';

export const BOTTOM_SNS_CONSTANTS: Record<string, TextVariant> = {
  appDownload: {
    common: '피망 쇼다운 앱 다운로드',
    mobile: '피망 쇼다운\n 앱 다운로드',
  },
  kakaoChannel: { common: 'JOPT 카카오톡 채널', mobile: 'JOPT\n 카카오톡 채널' },
  youtube: { common: '피망 포커스 유튜브', mobile: '피망 포커스\n 유튜브' },
  detail: { common: '대회 상세 안내', mobile: '대회\n 상세 안내' },
};
